import type { AgentTrustReceipt } from './agentTrustReceiptModel.ts';

export const resolveAgentTrustReceipt = (_contentId: string): AgentTrustReceipt | null => null;
